module.exports = __webpack_public_path__ + "images/logo-orange-144x144.c1c455aac0a4951d003b4069eb72e5d9.png";